import queryString from "query-string";
import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Grid, Dimmer, Loader } from "semantic-ui-react";
import {
  checkRegistrationTokenFailure as noRegistrationToken,
  confirmRegistration
} from "../actions/registrations/registrations";
import CustomFailure from "../components/common/CustomFailure";
import ConfirmRegistration from "../components/registrations/ConfirmRegistration";
import { amRoutes } from "../config/config";
import { doesNotExist } from "../utils/utils";

const ConfirmRegistrationView = ({ location }) => {
  const dispatch = useDispatch();
  const registrationToken = queryString.parse(location.search).registration_token;

  if (doesNotExist(registrationToken)) {
    dispatch(noRegistrationToken("No registration token provided"));
  }
  const onConfirm = useMemo(() => () => dispatch(confirmRegistration({ registrationToken })), [
    dispatch,
    registrationToken
  ]);

  const [
    checkRegistrationTokenStart,
    checkRegistrationTokenFailure,
    checkRegistrationTokenFailureMessage,
    confirmRegistrationStart,
    confirmRegistrationFailure,
    showSuccessMessage,
    submitSucceededMessageHeader,
    submitSucceededMessageContent
  ] = useSelector(({ registrations, statusMessages }) => [
    registrations.checkRegistrationTokenStart,
    registrations.checkRegistrationTokenFailure,
    registrations.checkRegistrationTokenFailureMessage,
    registrations.confirmRegistrationStart,
    registrations.confirmRegistrationFailure,
    statusMessages.showSuccessMessage,
    statusMessages.submitSucceededMessageHeader,
    statusMessages.submitSucceededMessageContent
  ]);
  let content;
  let style = { maxWidth: 500 };
  if (checkRegistrationTokenFailure || confirmRegistrationFailure) {
    content = (
      <CustomFailure
        header="User confirmation failed"
        content={checkRegistrationTokenFailureMessage}
        infoContent={
          <>
            Already confirmed account? Click
            <Link to={amRoutes.login}> here</Link>, to login.
          </>
        }
      />
    );
  } else {
    style = { display: "inline" };
    content = (
      <ConfirmRegistration
        loading={confirmRegistrationStart}
        onConfirm={onConfirm}
        showSuccessMessage={showSuccessMessage}
        successMessageHeader={submitSucceededMessageHeader}
        successMessageContent={submitSucceededMessageContent}
      />
    );
  }
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100vh"
      }}
    >
      <Grid textAlign="center" style={{ height: "100%" }} verticalAlign="middle">
        {checkRegistrationTokenStart && (
          <Dimmer active>
            <Loader />
          </Dimmer>
        )}
        <Grid.Column style={style}>{content}</Grid.Column>
      </Grid>
    </div>
  );
};

export default ConfirmRegistrationView;
